// import { createBrowserHistory } from 'history';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Router } from 'react-router-dom';

import { ROUTES } from 'Routing/routesSaga';
import { buildBeforeRouteChange } from 'Routing/Actions';
import { basename, history } from './history';

/**
 * React router V6 seems to not support side effects history.push (in actions)
 * custom router is created to make history.push available
 */
export const CustomRouter = props => {
  const dispatch = useDispatch();
  const [state, setState] = React.useState({
    action: history.action,
    location: history.location,
  });
  React.useLayoutEffect(() => history.listen(setState), []);

  // this could be use to log module access
  React.useEffect(() => {
    let prevModule = '';

    const logModuleAccess = ({ location, action }) => {
      const module = location.pathname;
      if (module !== prevModule) {
        prevModule = module;
      }

      const matchingRoute = ROUTES.find(
        route => route.pattern === location.pathname
      );

      dispatch(
        buildBeforeRouteChange({
          route: matchingRoute,
          previousRoute: prevModule,
        })
      );
    };

    // log initial module - in case route was provided or page was refreshed
    logModuleAccess({ location });

    // log on route changes
    history.listen(logModuleAccess);
  }, [dispatch]);

  return (
    <Router
      {...props}
      location={state.location}
      navigationType={state.action}
      navigator={history}
      history={history}
      basename={basename}
    />
  );
};
